/* ---------- CP-002's earth test, one PE core at a time (#3778, #3789 review 1) ----------
 * Each pump's two cables land their PE cores on blocks of their own, and the earth test reads each core alone (commission.ts): its
 * readings are "pump 1 core 1", "pump 1 core 2"…, no longer "pump 1 earth". A save made before holds the pair's reading under the
 * old id, which the record would drop unseen. How such a save is read: the save migration in packages/progress uses this (format 35).
 * Self-contained on purpose, as deltafeedback.ts: the migration imports this file alone, not CP-002's pack. */

/** The pumps' old earth readings and the readings that replace each. */
export const CP002_EARTH_CORES = [1, 2].map(n => ({ old: `pump ${n} earth`, now: [`pump ${n} core 1`, `pump ${n} core 2`] }));

/** A commissioning record with each old earth reading put in its log ("changed", as a panel changed after the readings), the
 *  readings that replace it to be taken again (stale), and a signature over it dropped: the signed report no longer matches its tests. */
function record(c: any): any {
  if (!c || typeof c !== "object" || !c.readings || typeof c.readings !== "object") return c;
  const found = CP002_EARTH_CORES.filter(e => e.old in c.readings); if (!found.length) return c;
  const readings = { ...c.readings }, log = [...(Array.isArray(c.log) ? c.log : [])], stale = new Set<string>(Array.isArray(c.stale) ? c.stale : []);
  for (const e of found) { const r = readings[e.old]; log.push({ id: e.old, reading: r?.reading, pass: r?.pass, at: r?.at, why: "changed" }); delete readings[e.old]; e.now.forEach(id => stale.add(id)); }
  const out: any = { ...c, readings, log, stale: [...stale] }; delete out.signed;
  return out;
}
const one = <A extends { ui?: any }>(s: A): A => {
  const c = s?.ui?.commission, r = record(c);
  return r === c ? s : { ...s, ui: { ...s.ui, commission: r } };
};
/** A saved CP-002 project with its earth readings moved to the per-core test: its own work and each earlier attempt it keeps. */
export function earthCoresCp002Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s?.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
